import Swiper from 'swiper/bundle';
import { Controller } from '@hotwired/stimulus';

export default class CarouselController extends Controller {
  static values = {
    slidesPerView: { type: Number, default: 2.2 },
    slidesPerViewSm: { type: Number, default: 1 },
    slidesPerViewMd: { type: Number, default: 1 },
    navigation: { type: Boolean, default: true },
    slidesGap: { type: Number, default: 24 },
    loop: { type: Boolean, default: true },
  }

  static targets = [
    'swiperButtonPrev',
    'swiperButtonNext',
    'swiperContainer',
  ]

  connect() {
    super.connect()
    this.swiper = new Swiper(this.swiperContainerTarget, this.defaultOptions)
  }

  dismissSlide(event) {
    const slide = event.currentTarget.closest('.swiper-slide')
    if (!slide) return

    const index = Array.from(this.swiper.slides).indexOf(slide)
    if (index !== -1) {
      this.swiper.removeSlide(index)
    }
  }

  get defaultOptions() {
    let navigationOptions = null

    if (this.navigationValue && this.hasSwiperButtonNextTarget && this.hasSwiperButtonPrevTarget) {
      navigationOptions = {
        nextEl: this.swiperButtonNextTarget,
        prevEl: this.swiperButtonPrevTarget,
      }
    }

    return {
      navigation: this.navigationValue ? navigationOptions : false,
      spaceBetween: this.slidesGapValue,
      slidesPerView: this.slidesPerViewSmValue,
      loop: this.loopValue,
      breakpoints: {
        768: {
          slidesPerView: this.slidesPerViewMdValue,
        },
        1200: {
          slidesPerView: this.slidesPerViewValue,
        },
      },
    }
  }
}
